import { useState } from 'react';
import { Check } from '@mui/icons-material';
import { Chip, Stack, Typography } from '@mui/material';
import { budgets } from './bugets';
import { ConfirmDialog } from '@/components/shared/confirm-dialog';

interface MonthlyBudgetEditDialogProps {
  currentValue: string | null;
  onClose: () => void;
  onSave: (value: string | null) => void;
}

export const MonthlyBudgetEditDialog = ({
  currentValue,
  onClose,
  onSave,
}: MonthlyBudgetEditDialogProps) => {
  const [value, setValue] = useState<string | null>(currentValue);

  const handleSave = () => {
    onSave(value);
    onClose();
  };

  return (
    <ConfirmDialog
      actionLabels={{
        cancel: 'Cancelar',
        confirm: 'Salvar',
      }}
      onClose={onClose}
      open
      onConfirm={handleSave}
      title="Orçamento mensal"
    >
      <Stack gap={1} alignItems="flex-start">
        <Typography>Selecione o orçamento mensal</Typography>
        {budgets.map(({ label, value: optionValue }) => {
          const isChecked = value === optionValue;
          return (
            <Chip
              key={optionValue}
              label={label}
              variant={isChecked ? 'filled' : 'outlined'}
              icon={isChecked ? <Check fontSize="small" /> : undefined}
              onClick={() => {
                setValue(optionValue);
              }}
            />
          );
        })}
      </Stack>
    </ConfirmDialog>
  );
};
